import { Auth } from "../repository/api/auth/auth"
import { AuthorizationUseCases } from "../useCase/authorization/authorization"

import { LandingsRepository } from "../repository/api/landing/landing" 
import { UploadTasksRepository } from "../repository/api/uploadtask/uploadtask"

import { LandingUseCases } from "../useCase/landing/landing" 
import { UploadTaskUseCases } from "../useCase/uploadtask/uploadtask"
import { UserUseCases } from "../useCase/users/user"
import { UsersRepository } from "../repository/api/user/user"


export const useUseCases = (actions:any) => {
    const authUseCase = new AuthorizationUseCases(new Auth(), actions)

    const landingUseCase = new LandingUseCases(new LandingsRepository(), actions) 
    const uploadtaskUseCase = new UploadTaskUseCases(new UploadTasksRepository(), actions)

    const userUseCase =  new UserUseCases(new UsersRepository(), actions)

    return {authUseCase, landingUseCase, uploadtaskUseCase, userUseCase}
}
